import * as z from 'zod';

export const ctcLevelFormSchema = z.object({
  Level: z.string().trim().min(1, { message: 'CTC_LEVEL_REQUIRED' }),
  CTC: z
    .string()
    .trim()
    .min(1, { message: 'CTC_AMOUNT_REQUIRED' })
    .regex(/^\d+$/, { message: 'CTC_AMOUNT_INVALID' }),
  Ranks: z.string().trim().optional(),
});

export type CtcLevelFormValues = z.infer<typeof ctcLevelFormSchema>;
